const { server_url } = require("../../const/const.json");
const apiSender = require("../api-sender");
const submitVia = (data) => {
  let route = `${server_url}/api/webapp/logging`;
  return apiSender
    .postFb(route, data)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      console.log(err);
      throw new Error(err.message);
    });
};
module.exports = {
  submitVia,
};
